import styled from '@emotion/styled'

const StyledAvatar = styled.div`
  ${({ style }) => {
    return { ...style }
  }}
  width:${({ width }) => width}px;
  height: ${({ height }) => height}px;
  border-radius: 50%;
  cursor: pointer;
  img {
    border-radius: 50%;
  }
  > span {
    display: inline-block;
    width: 100%;
    border-radius: 50%;
    background: ${({ backgroundColor }) => backgroundColor};
    color: ${({ textColor }) => textColor};
    font-size: var(--font-size-sm);
    text-align: center;
    line-height: ${({ height }) => height}px;
    white-space: nowrap;
    color: ${({ textColor }) => {
      return textColor || 'var(--ow-text-inverse-color)'
    }};
  }
`

export { StyledAvatar }
